import React, { useEffect, useState } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  TextField,
  Typography,
  Button,
  Tabs,
  Grid,
  Tab,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Pagination from "@mui/material/Pagination";
import CollectionsIcon from "@mui/icons-material/Collections";
import { fetchCategories } from "../../../redux/slices/orgAdmin/categoriesOrgSlice";
import { Select, MenuItem, InputLabel, FormControl, Chip } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { fetchLanguages } from "../../../redux/slices/superAdmin/languagesSlice";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import Tooltip from "@mui/material/Tooltip";
import ReactQuill from "react-quill";
import { orderSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useSelector, useDispatch } from "react-redux";
import { deleteSectionData } from "../../../redux/slices/orgAdmin/promotionsSlice";
import FilterButton from "./Components/FilterButton";
import { buildMedia } from "../../Utils/AuthService";
import { rowsPerPage } from "../../../Constants";
import GalleryUpload from "./Utils/GalleryUpload";
import { useMediaQuery, useTheme } from "@mui/material";
import Tags from "./Components/Tags";
import { listTags } from "../../../redux/slices/orgAdmin/tagsOrgSlice";
import {
  StyledButton,
  StyledContainer,
  StyledTableCell,
} from "../../CSS/Styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { fetchNews } from "../../../redux/slices/orgAdmin/newsSlice";
import Attachments from "./Utils/Attachments";
import {
  fetchPodcasts,
  getVideo,
  savePodcast,
} from "../../../redux/slices/orgAdmin/podcastsSlice";

export default function Podcasts() {
  const dispatch = useDispatch();
  const sectionId = 5;
  const { podcastsContent, loading } = useSelector((state) => state.podcasts);
  const { languagesList } = useSelector((state) => state.languages);
  const { companyId } = useSelector((state) => state.app);
  const { categories } = useSelector((state) => state.categories);
  const [deleteTitle, setDeleteTitle] = useState("");
  const [selectedCategories, setSelectedCategories] = useState();
  const [selectedCategoriesEDIT, setSelectedCategoriesEDIT] = useState();
  const [triggerSubmit, setTriggerSubmit] = useState(false);
  const [selectedFilterId, setSelectedFilterId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [localPodcats, setLocalPodcasts] = useState([]);
  const [isSorting, setIsSorting] = useState(false);
  const [media, setMedia] = useState(null);
  const { tags } = useSelector((state) => state.tags);

  const files = {};
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [page, setPage] = useState(1);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    dispatch(fetchCategories({ companyId, sectionId }));
  }, [dispatch, sectionId]);

  useEffect(() => {
    dispatch(fetchPodcasts({ companyId, page, limit: rowsPerPage }));
    if (!languagesList?.length) {
      dispatch(fetchLanguages());
    }
  }, [dispatch, page]);

  useEffect(() => {
    dispatch(listTags({ companyId }));
  }, [dispatch, companyId]);

  useEffect(() => {
    if (podcastsContent?.data) {
      setLocalPodcasts(podcastsContent.data);
    }
  }, [podcastsContent]);

  const totalRecords =
    podcastsContent?.pagination?.totalRecords || podcastsContent?.length;
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  const [rowToEdit, setRowToEdit] = useState(null);

  const [isAddingNews, setIsAddingNews] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState("");
  const [defaultLanguage, setDefaultLanguage] = useState(null);
  const availableLanguages = languagesList?.map((lang) => lang.code);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [promotionIdToDelete, setPromotionIdToDelete] = useState(null);
  const [galleryDialogOpen, setGalleryDialogOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    if (languagesList.length) {
      const defaultLang =
        languagesList.find(
          (lang) => lang.is_default === 1 || lang.is_default === "1"
        )?.code || "en";
      setCurrentLanguage(defaultLang);
      setDefaultLanguage(defaultLang);
    }
  }, [languagesList]);

  const handleCategoryChange = (event) => {
    if (isEditing) {
      setSelectedCategoriesEDIT(event.target.value);
      setSelectedCategory(event.target.value.category_name);
    } else {
      setSelectedCategories(event.target.value);
    }
  };

  const [galleryId, setGalleryId] = useState(null);
  const [newNews, setNewNews] = useState({
    date: null,
    SEO: {
      en: { title: "", tags: "", description: "" },
      fr: { title: "", tags: "", description: "" },
      ar: { title: "", tags: "", description: "" },
    },
    en: {
      title: "",
      summary: "",
      description: "",
      host_name1_fullname: "",
      host_name2_fullname: "",
      host_name3_fullname: "",
      invited1_fullname: "",
      invited2_fullname: "",
      invited3_fullname: "",
      yt_url: "",
    },
    fr: {
      title: "",
      summary: "",
      description: "",
      host_name1_fullname: "",
      host_name2_fullname: "",
      host_name3_fullname: "",
      invited1_fullname: "",
      invited2_fullname: "",
      invited3_fullname: "",
      yt_url: "",
    },
    ar: {
      title: "",
      summary: "",
      description: "",
      host_name1_fullname: "",
      host_name2_fullname: "",
      host_name3_fullname: "",
      invited1_fullname: "",
      invited2_fullname: "",
      invited3_fullname: "",
      yt_url: "",
    },
    // attachments: {
    //   mainImage: null,
    //   transcript: null,
    //   gallery: [],
    // },
  });

  const handleDeleteMainImage = (isDeleted) => {
    setNewNews((prev) => ({
      ...prev,
      deleteMainImage: isDeleted, // ✅ Dynamically update promotionData
    }));
  };

  const handleDeleteAttachment = (language, attachmentId) => {
    setNewNews((prev) => {
      const updatedDeletedAttachments = new Set(prev.deletedAttachments || []);

      // Add language to the Set if an attachment was deleted
      updatedDeletedAttachments.add(language);

      return {
        ...prev,
        deletedAttachments: Array.from(updatedDeletedAttachments), // Convert Set back to Array
      };
    });
  };

  const [confirmationDialogOpen, setConfirmationDialogOpen] = useState(false);

  const formatToLocalDate = (dateString) => {
    const date = new Date(dateString); // Convert string to Date
    const localDate = new Date(date.toLocaleString()); // Localized date
    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, "0"); // Months are zero-indexed
    const day = String(localDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`; // Format as YYYY-MM-DD
  };

  useEffect(() => {
    dispatch(fetchNews());
    setIsSorting(false);
  }, [dispatch]);

  const handleShowGallery = (id, title) => {
    setGalleryId(id);
    setGalleryDialogOpen(true);
    setDeleteTitle(title);
  };

  const handleInputChange = (language, field, value, section = null) => {
    setNewNews((prev) => {
      if (section) {
        return {
          ...prev,
          [section]: {
            ...prev[section],
            [language]: {
              ...prev[section][language],
              [field]: value,
            },
          },
        };
      }
      return {
        ...prev,
        [language]: {
          ...prev[language],
          [field]: value,
        },
      };
    });
  };

  const [selectedTags, setSelectedTags] = useState([]);

  const confirmDelete = () => {
    dispatch(deleteSectionData({ id: promotionIdToDelete }))
      .then(() => {
        setDeleteDialogOpen(false);
        setPromotionIdToDelete(null);

        // Safely compute updated total
        const updatedTotalRecords = Math.max(
          0,
          (podcastsContent?.pagination?.totalRecords ??
            podcastsContent?.length ??
            0) - 1
        );

        const updatedTotalPages = Math.ceil(updatedTotalRecords / rowsPerPage);
        const newPage = Math.max(
          1,
          page > updatedTotalPages ? updatedTotalPages : page
        );

        setPage(newPage); // If you're using local state for page

        dispatch(
          fetchPodcasts({ companyId, page: newPage, limit: rowsPerPage })
        );
      })
      .catch((error) => {
        console.error("Error deleting podcast:", error);
      });
  };

  const handleGlobalChange = (field, value) => {
    setNewNews((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDeleteClick = (id, title) => {
    setPromotionIdToDelete(id);
    setDeleteDialogOpen(true);
    setDeleteTitle(title);
  };

  // attachments: {
  //   mainImage: null,
  //   report: null,
  //   gallery: [],
  // },

  const handleAddNews = () => {
    setSelectedTags([]);
    setIsEditing(false);
    setSelectedCategory(null);
    setSelectedCategories(null);
    setRowToEdit(null);
    setMedia(null);
    setNewNews({
      date: null,
      yt_url: "",
      SEO: {
        en: { title: "", tags: "", description: "" },
        fr: { title: "", tags: "", description: "" },
        ar: { title: "", tags: "", description: "" },
      },
      en: {
        title: "",
        summary: "",
        description: "",
        host_name1_fullname: "",
        host_name2_fullname: "",
        host_name3_fullname: "",
        invited1_fullname: "",
        invited2_fullname: "",
        invited3_fullname: "",
        yt_url: "",
      },
      fr: {
        title: "",
        summary: "",
        description: "",
        host_name1_fullname: "",
        host_name2_fullname: "",
        host_name3_fullname: "",
        invited1_fullname: "",
        invited2_fullname: "",
        invited3_fullname: "",
        yt_url: "",
      },
      ar: {
        title: "",
        summary: "",
        description: "",
        host_name1_fullname: "",
        host_name2_fullname: "",
        host_name3_fullname: "",
        invited1_fullname: "",
        invited2_fullname: "",
        invited3_fullname: "",
        yt_url: "",
      },
      // attachments: {
      //   mainImage: null,
      //   transcript: null,
      //   gallery: [],
      // },
    });
    setCurrentLanguage(currentLanguage);
    setIsAddingNews(true);
  };

  const handleSaveLanguage = () => {
    if (currentLanguage === "ar") {
      handleExitAndSave();
    } else {
      setConfirmationDialogOpen(true);
    }
  };

  const handleAttachmentsChange = (newAttachments) => {
    setNewNews((prevNews) => {
      const prevAttachments = prevNews.attachments || {};

      return {
        ...prevNews,
        attachments: {
          ...prevAttachments,
          [`attachment_${currentLanguage}`]:
            newAttachments.report ??
            prevAttachments[`attachment_${currentLanguage}`],

          mainImage: newAttachments.hasOwnProperty("mainImage")
            ? newAttachments.mainImage
            : (prevAttachments.mainImage ?? null),
        },
      };
    });
  };

  const handleProceedToNextLanguage = () => {
    setConfirmationDialogOpen(false);

    if (currentLanguage === "en") {
      setCurrentLanguage("fr");
    } else if (currentLanguage === "fr") {
      setCurrentLanguage("ar");
    }
  };

  const handleEditVideo = async (id) => {
    try {
      setRowToEdit(id);
      setIsEditing(true);
      const actualId = id && typeof id === "object" ? id.id : id;

      const videoData = await dispatch(getVideo({ id: actualId })).then(
        (res) => res.payload
      );

      if (
        videoData?.status === "error" &&
        videoData.message === "Record not found"
      ) {
        alert("Record not found.");
        return;
      }

      if (!videoData || !videoData.data) return;

      const extractSEO = (seoData) => {
        try {
          return seoData
            ? JSON.parse(seoData)
            : { title: "", tags: "", description: "" };
        } catch (error) {
          console.error("Error parsing SEO data:", error);
          return { title: "", tags: "", description: "" };
        }
      };

      const eventId = videoData.data?.id;
      const mainImage = videoData.data?.mainImage || "";

      const attachments = Object.keys(videoData.data)
        .filter(
          (lang) =>
            availableLanguages.includes(lang) &&
            videoData.data[lang]?.attachment
        )
        .map((lang) => ({
          languageId: lang,
          fileName: videoData.data[lang].attachment,
        }));

      const mediaData = buildMedia(companyId, eventId, mainImage, attachments);

      setMedia(mediaData);
      setSelectedCategory(videoData.data[defaultLanguage]?.category_name);
      setSelectedCategoriesEDIT(videoData.data[defaultLanguage]?.fk_categoryId);

      const tag_ids = videoData.data?.[defaultLanguage]?.tag_ids || [];
      const tag_names = videoData.data?.[defaultLanguage]?.tag_names || [];

      const selectedTagsFromResponse = tag_ids.map((id, index) => ({
        id,
        tag_name: tag_names[index] || "", // fallback in case of mismatch
      }));

      setSelectedTags(selectedTagsFromResponse);

      const prefilledEvent = {
        SEO: {
          en: extractSEO(videoData.data?.en?.SEO),
          fr: extractSEO(videoData.data?.fr?.SEO),
          ar: extractSEO(videoData.data?.ar?.SEO),
        },
        en: {
          fk_categoryId: videoData.data?.en?.fk_categoryId || null,
          title: videoData.data?.en?.title || "",
          summary: videoData.data?.en?.summary || "",
          description: videoData.data?.en?.description || "",
          yt_url: videoData.data?.en?.yt_url || "",
          delay: videoData.data?.en?.delay || "",
          host_name1_fullname: videoData.data?.en?.host1 || "",
          host_name2_fullname: videoData.data?.en?.host2 || "",
          host_name3_fullname: videoData.data?.en?.host3 || "",
          invited1_fullname: videoData.data?.en?.invited1 || "",
          invited2_fullname: videoData.data?.en?.invited2 || "",
          invited3_fullname: videoData.data?.en?.invited3 || "",
        },
        fr: {
          fk_categoryId: videoData.data?.fr?.fk_categoryId || null,
          title: videoData.data?.fr?.title || "",
          summary: videoData.data?.fr?.summary || "",
          description: videoData.data?.fr?.description || "",
          yt_url: videoData.data?.fr?.yt_url || "",
          delay: videoData.data?.fr?.delay || "",
          host_name1_fullname: videoData.data?.fr?.host1 || "",
          host_name2_fullname: videoData.data?.fr?.host2 || "",
          host_name3_fullname: videoData.data?.fr?.host3 || "",
          invited1_fullname: videoData.data?.fr?.invited1 || "",
          invited2_fullname: videoData.data?.fr?.invited2 || "",
          invited3_fullname: videoData.data?.fr?.invited3 || "",
        },
        ar: {
          fk_categoryId: videoData.data?.en?.fk_categoryId || null,
          title: videoData.data?.ar?.title || "",
          summary: videoData.data?.ar?.summary || "",
          description: videoData.data?.ar?.description || "",
          yt_url: videoData.data?.ar?.yt_url || "",
          delay: videoData.data?.ar?.delay || "",
          host_name1_fullname: videoData.data?.ar?.host1 || "",
          host_name2_fullname: videoData.data?.ar?.host2 || "",
          host_name3_fullname: videoData.data?.ar?.host3 || "",
          invited1_fullname: videoData.data?.ar?.invited1 || "",
          invited2_fullname: videoData.data?.ar?.invited2 || "",
          invited3_fullname: videoData.data?.ar?.invited3 || "",
        },
        date: videoData.data?.[defaultLanguage]?.date
          ? videoData.data?.[defaultLanguage].date
              .replace(" ", "T")
              .slice(0, 16)
          : "",
        id: videoData.data?.id || null,
        attachments: {
          mainImage: videoData.data?.mainImage || null,
          report: videoData.data?.attachments?.report || [],
        },
        deleteMainImage: false,
        deletedAttachments: [],
      };
      setNewNews(prefilledEvent);
      setCurrentLanguage(currentLanguage);
      setIsAddingNews(true);
    } catch (error) {
      console.error("Error fetching video data:", error);
    }
  };

  const handleFinalizeNews = (closeForm = true) => {
    const payload = rowToEdit
      ? { id: typeof rowToEdit === "object" ? rowToEdit.id : rowToEdit }
      : {};

    const files = {};
    let hasValidLanguageData = false; // Flag to check if at least one language has valid data

    const selectedTagIds = selectedTags.map((tag) => tag.id);

    Object.entries(newNews).forEach(([lang, data]) => {
      if (availableLanguages.includes(lang)) {
        const hasData =
          data.title?.trim() ||
          data.summary?.trim() ||
          data.description?.trim() ||
          data.invited1_fullname?.trim() ||
          data.invited2_fullname?.trim() ||
          data.invited3_fullname?.trim() ||
          data.host_name1_fullname?.trim() ||
          data.host_name2_fullname?.trim() ||
          data.host_name3_fullname?.trim() ||
          data.yt_url?.trim();

        if (hasData) {
          hasValidLanguageData = true; // Mark that at least one valid language entry exists
          payload[lang] = {
            selectedTags: selectedTagIds,
            fk_categoryId:
              isEditing && selectedCategoriesEDIT
                ? selectedCategoriesEDIT.id || selectedCategoriesEDIT
                : selectedCategories?.id || null,
            title: data.title?.trim() || "",
            summary: data.summary?.trim() || "",
            description: data.description?.trim() || "",
            invited1_fullname: data.invited1_fullname?.trim() || "",
            invited2_fullname: data.invited2_fullname?.trim() || "",
            invited3_fullname: data.invited3_fullname?.trim() || "",
            host_name1_fullname: data.host_name1_fullname?.trim() || "",
            host_name2_fullname: data.host_name2_fullname?.trim() || "",
            host_name3_fullname: data.host_name3_fullname?.trim() || "",
            date: newNews.date || null,
            yt_url: data.yt_url?.trim() || "",
            SEO: {
              title: newNews.SEO[lang]?.title?.trim() || "",
              tags: newNews.SEO[lang]?.tags?.trim() || "",
              description: newNews.SEO[lang]?.description?.trim() || "",
            },
          };
        }
      }
    });

    if (!hasValidLanguageData) {
      alert("Please fill at least one field before saving!");
      return;
    }

    if (newNews?.attachments?.mainImage?.length) {
      files["mainImage"] = newNews.attachments.mainImage[0].file;
    }

    Object.keys(payload).forEach((lang) => {
      if (newNews.attachments?.[`attachment_${lang}`]?.length) {
        files[`attachment_${lang}`] =
          newNews.attachments[`attachment_${lang}`][0].file;
      }
    });

    if (rowToEdit && newNews.deleteMainImage) {
      payload.deleteMainImage = true;
    }

    if (rowToEdit && newNews.deletedAttachments?.length > 0) {
      payload.deletedAttachments = newNews.deletedAttachments;
    }

    dispatch(savePodcast({ payload, sectionId, files }))
      .unwrap()
      .then(() => {
        dispatch(fetchPodcasts({ companyId, page, limit: rowsPerPage }));
        setTriggerSubmit(true);

        setSelectedCategories([]);
        setNewNews({
          date: null,
          SEO: {
            en: { title: "", tags: "", description: "" },
            fr: { title: "", tags: "", description: "" },
            ar: { title: "", tags: "", description: "" },
          },
          en: {
            title: "",
            summary: "",
            description: "",
            host_name1_fullname: "",
            host_name2_fullname: "",
            host_name3_fullname: "",
            invited1_fullname: "",
            invited2_fullname: "",
            invited3_fullname: "",
            yt_url: "",
          },
          fr: {
            title: "",
            summary: "",
            description: "",
            host_name1_fullname: "",
            host_name2_fullname: "",
            host_name3_fullname: "",
            invited1_fullname: "",
            invited2_fullname: "",
            invited3_fullname: "",
            yt_url: "",
          },
          ar: {
            title: "",
            summary: "",
            description: "",
            host_name1_fullname: "",
            host_name2_fullname: "",
            host_name3_fullname: "",
            invited1_fullname: "",
            invited2_fullname: "",
            invited3_fullname: "",
            yt_url: "",
          },
        });
        setConfirmationDialogOpen(false);
      })
      .catch((error) => {
        console.error("Error saving event:", error);
      });
    if (closeForm) {
      setIsAddingNews(false);
    }
  };

  const onDragEnd = (result) => {
    if (!result.destination) return;

    // Reorder the items in local state
    const reorderedItems = Array.from(localPodcats);
    const [removed] = reorderedItems.splice(result.source.index, 1);
    reorderedItems.splice(result.destination.index, 0, removed);

    // Update local state for immediate UI feedback
    setLocalPodcasts(reorderedItems);

    // Prepare the payload for dispatch with the reordered data
    const reorderedData = reorderedItems.map((item, index) => ({
      id: item.id,
      sortIndex: index + 1, // Assuming that you want to track the index for sorting
    }));

    // Dispatch the action to persist changes in the order
    dispatch(orderSectionData(reorderedData))
      .unwrap()
      .then(() => {
        dispatch(
          fetchPodcasts({
            companyId,
            page,
            limit: rowsPerPage,
            categoryId: selectedFilterId,
          })
        );
        setIsSorting(true);
      })
      .catch((error) => {
        console.error("Error updating order:", error);
      });
  };

  const handleExitAndSave = () => {
    handleFinalizeNews();
    setConfirmationDialogOpen(false);
  };

  const handleFilterChange = (selectedOption) => {
    setSelectedFilterId(selectedOption.id);
    setIsSorting(true);
    dispatch(
      fetchPodcasts({
        companyId,
        page,
        limit: rowsPerPage,
        categoryId: selectedOption.id,
      })
    );
  };

  return (
    <StyledContainer>
      <Paper elevation={3} sx={{ padding: 3 }}>
        {!isAddingNews && (
          <>
            <Typography variant="h5" sx={{ mb: 2 }}>
              Videos
            </Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <StyledButton
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={handleAddNews}
                  sx={{ marginBottom: 2 }}
                >
                  Add
                </StyledButton>
                <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                  <TextField
                    type="number"
                    label="Edit by ID"
                    variant="outlined"
                    value={rowToEdit}
                    onChange={(e) => setRowToEdit(e.target.value)}
                    size="small"
                    sx={{ marginRight: 1 }}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleEditVideo(parseInt(rowToEdit))}
                    disabled={loading || !rowToEdit}
                  >
                    Edit
                  </Button>
                </Box>
              </Grid>
              <Grid item xs={6} display="flex" justifyContent="flex-end">
                {categories?.length > 1 && (
                  <FilterButton
                    options={categories?.map((category) => ({
                      label: category.category_name,
                      id: category.id,
                    }))}
                    onFilterChange={handleFilterChange}
                    loading={loading}
                  />
                )}
              </Grid>
            </Grid>
            <TableContainer component={Paper}>
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="newsTable">
                  {(provided) => (
                    <Table ref={provided.innerRef} {...provided.droppableProps}>
                      <TableHead>
                        <TableRow>
                          <StyledTableCell width="5%"></StyledTableCell>
                          <StyledTableCell
                            width={languagesList?.length >= 2 ? "65%" : "80%"}
                          >
                            Title
                          </StyledTableCell>

                          <StyledTableCell width="15%">Actions</StyledTableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(podcastsContent?.data || []).map((item, index) => (
                          <Draggable
                            key={item.id}
                            draggableId={item.id.toString()}
                            index={index}
                            isDragDisabled={!isSorting}
                          >
                            {(provided, snapshot) => (
                              <TableRow
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                style={{
                                  ...provided.draggableProps.style,
                                  backgroundColor: snapshot.isDragging
                                    ? "#f5f5f5"
                                    : "inherit",
                                }}
                              >
                                {/* Drag Handle with Tooltip */}
                                <TableCell {...provided.dragHandleProps}>
                                  <Tooltip
                                    title={
                                      isSorting
                                        ? ""
                                        : "You can only sort when filtering"
                                    }
                                  >
                                    {categories?.length > 1 && (
                                      <span>
                                        <DragIndicatorIcon
                                          style={{
                                            cursor: !isSorting
                                              ? "not-allowed"
                                              : "grab",
                                            opacity: !isSorting ? 0.5 : 1,
                                          }}
                                        />
                                      </span>
                                    )}
                                  </Tooltip>
                                </TableCell>

                                {/* Title */}
                                <TableCell>{item.title || "N/A"}</TableCell>

                                {/* Actions */}
                                <TableCell>
                                  <IconButton
                                    onClick={() => handleEditVideo(item)}
                                  >
                                    <EditIcon />
                                  </IconButton>
                                  <IconButton
                                    onClick={() =>
                                      handleDeleteClick(item.id, item.title)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>

                                  <IconButton
                                    onClick={() =>
                                      handleShowGallery(item.id, item.title)
                                    }
                                  >
                                    <CollectionsIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    </Table>
                  )}
                </Droppable>
              </DragDropContext>
            </TableContainer>
            <Box mt={2} display="flex" justifyContent="center">
              <Pagination
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                color="primary"
                size="large"
              />
            </Box>
          </>
        )}

        {isAddingNews && (
          <Box>
            <Box display="flex" alignItems="center" gap={1} mb={2}>
              <IconButton onClick={() => setIsAddingNews(false)}>
                <ArrowBackIcon />
              </IconButton>
              <Typography variant="h6">Video</Typography>
            </Box>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Category</InputLabel>
              <Select
                value={isEditing ? selectedCategory : selectedCategories || ""}
                onChange={handleCategoryChange}
                renderValue={(selected) =>
                  selected ? (
                    <Chip
                      key={isEditing ? selected : selected.id}
                      label={isEditing ? selected : selected.category_name}
                    />
                  ) : (
                    ""
                  )
                }
              >
                {categories?.map((category) => (
                  <MenuItem key={category.id} value={category}>
                    {category.category_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Tags
              tags={tags}
              selectedTags={selectedTags}
              setSelectedTags={setSelectedTags}
            />
            {languagesList?.length > 1 && (
              <Tabs
                value={currentLanguage}
                indicatorColor="primary"
                textColor="primary"
                onChange={(e, newValue) => setCurrentLanguage(newValue)}
              >
                {languagesList?.map((lang) => (
                  <Tab key={lang.code} value={lang.code} label={lang.name} />
                ))}
              </Tabs>
            )}
            <Box
              sx={{
                padding: 3,
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Accordion
                defaultExpanded
                sx={{
                  height: "600px",
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    General Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TextField
                    label="Title"
                    value={newNews[currentLanguage]?.title || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "title",
                        e.target.value
                      )
                    }
                    fullWidth
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    label="Summary"
                    value={newNews[currentLanguage]?.summary || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "summary",
                        e.target.value
                      )
                    }
                    fullWidth
                  />
                  <ReactQuill
                    key={currentLanguage}
                    style={{
                      marginTop: "20px",
                      height: !isMobile ? "300px" : "auto",
                    }}
                    value={newNews[currentLanguage]?.description || ""}
                    onChange={(value) =>
                      handleInputChange(currentLanguage, "description", value)
                    }
                    theme="snow"
                    placeholder="Description..."
                    modules={{
                      toolbar: [
                        [{ header: "1" }, { header: "2" }, { font: [] }],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["bold", "italic", "underline"],
                        [{ align: [] }],
                        ["link"],
                        [{ color: [] }, { background: [] }],
                        ["clean"],
                      ],
                    }}
                  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    Podcast Data
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TextField
                    label="YouTube URL"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.yt_url || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "yt_url",
                        e.target.value
                      )
                    }
                  />{" "}
                  <TextField
                    label="Host Name 1"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.host_name1_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "host_name1_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    label="Host Name 2"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.host_name2_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "host_name2_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    label="Host Name 3"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.host_name3_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "host_name3_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    label="Guest 1 Name"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.invited1_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "invited1_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    label="Guest 2 Name"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.invited2_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "invited2_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    label="Guest 3 Name"
                    fullWidth
                    variant="outlined"
                    sx={{ mt: 2 }}
                    value={newNews[currentLanguage]?.invited3_fullname || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "invited3_fullname",
                        e.target.value
                      )
                    }
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    type="date"
                    label="Date"
                    InputLabelProps={{ shrink: true }}
                    value={newNews?.date ? formatToLocalDate(newNews.date) : ""} // Convert correctly
                    onChange={(e) => handleGlobalChange("date", e.target.value)}
                    onMouseDown={(e) => {
                      e.preventDefault();
                      e.target.showPicker();
                    }}
                    fullWidth
                  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    SEO
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO Title"
                    value={newNews.SEO[currentLanguage]?.title || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "title",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO tags"
                    value={newNews.SEO[currentLanguage]?.tags || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "tags",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />
                  <TextField
                    sx={{ mt: 2 }}
                    label="SEO Description"
                    multiline
                    rows={4}
                    value={newNews.SEO[currentLanguage]?.description || ""}
                    onChange={(e) =>
                      handleInputChange(
                        currentLanguage,
                        "description",
                        e.target.value,
                        "SEO"
                      )
                    }
                    fullWidth
                  />
                </AccordionDetails>
              </Accordion>

              <Accordion
                sx={{
                  marginBottom: 2,
                  border: "1px solid #ddd",
                  borderRadius: 2,
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#353634" }} />}
                >
                  <Typography sx={{ fontWeight: "bold", fontSize: "18px" }}>
                    Attachments
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Attachments
                    onAttachmentsChange={handleAttachmentsChange}
                    media={media}
                    currentLanguage={currentLanguage}
                    onDeleteMainImage={handleDeleteMainImage}
                    onDeleteAttachment={handleDeleteAttachment}
                  />
                </AccordionDetails>
              </Accordion>
            </Box>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button
                color="error"
                variant="contained"
                onClick={() => {
                  setIsAddingNews(false);
                  setRowToEdit(null);
                }}
              >
                Cancel
              </Button>
              <Button
                sx={{ ml: 2 }}
                color="primary"
                variant="contained"
                onClick={handleSaveLanguage}
              >
                {languagesList?.length > 1 ? "SAVE OR SKIP" : "SAVE"}
              </Button>
            </Box>
          </Box>
        )}

        <Dialog
          open={deleteDialogOpen}
          onClose={() => setDeleteDialogOpen(false)}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete{" "}
              <span style={{ fontWeight: "bold" }}> {deleteTitle}</span>? This
              action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
            <Button color="error" onClick={confirmDelete}>
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={confirmationDialogOpen}
          onClose={() => setConfirmationDialogOpen(false)}
        >
          <DialogTitle>Proceed to Next Language?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you want to proceed to the next language or finalize this
              video?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleExitAndSave} color="primary">
              Exit And Save
            </Button>
            <Button onClick={handleProceedToNextLanguage} color="primary">
              Next Language
            </Button>
          </DialogActions>
        </Dialog>

        <GalleryUpload
          galleryDialogOpen={galleryDialogOpen}
          setGalleryDialogOpen={setGalleryDialogOpen}
          deleteTitle={deleteTitle}
          fk_sectionDataId={galleryId}
          companyId={companyId}
        />
      </Paper>
    </StyledContainer>
  );
}
